import type { ReactNode } from 'react';
import { Card } from '@/components/Shared/Card';

/** One card of the tenant settings page: title, muted description, fields. */
export function Section({ title, description, children }: { title: string; description?: string; children: ReactNode }) {
  return (
    <Card title={title}>
      <div className="space-y-4">
        {description && <p className="text-[12px] text-slate-500 -mt-1">{description}</p>}
        {children}
      </div>
    </Card>
  );
}

/** Two-column field grid of a settings section (one column on small screens). */
export function Grid({ children }: { children: ReactNode }) {
  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">{children}</div>;
}
